<template>
  <div>
    <b-modal ref="empty-modal" size="lg" hide-footer title="Empty Bin Prompt">
      <div class="d-block text-center">
      <!-- <label><b>Bin Information:</b> {{ binTitle }} </label> -->
        <p class="my-4 mr-12 modalp">These Bins: <b>{{ binsToEmpty }}</b> are ready to ship would you like to Empty the Bins?</p>
      </div>
      <div class="row">
        <div class="col-md-7 col-lg-7 col-xl-7 text-center">
          <b-button class="mt-3" variant="dark" @click="emptyMyBin">Empty</b-button>
        </div>

        <div class="col-md-5 col-lg-5 col-xl-5 text-left">
          <b-button type="button" class="mt-3" variant="outline-warning" @click="hideModal">Close</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal ref="emptied-modal" size="lg" hide-footer title="Bin Has Been Emptied">
      <div class="d-block text-center">
      <!-- <label><b>Bin Information:</b> {{ binTitle }} </label> -->
        <p class="my-4 mr-12 modalp">These Bins: <b>{{ binsToEmpty }}</b> Have Been Emptied!!!</p>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-12 col-xl-12 text-center">
          <b-button class="mt-3" variant="outline-info" @click="hideModal2">Close</b-button>
        </div>

        <!-- <div class="col-md-5 col-lg-5 col-xl-5 text-left">
          <b-button type="button" class="mt-3" variant="outline-warning" @click="hideModal">Close</b-button>
        </div> -->
      </div>
    </b-modal>
    <div class="row">
      <div class="col-md-4">
        <card class="card" title="Shelve Order">
          <div>
            <form @submit.prevent>
              <div class="row">
                <div class="col-md-12">
                  <fg-input type="text" label="Barcode ID" v-model="toShelve.barcode" @keyup.enter.native="getOrderByBarcodeID">
                  </fg-input>
                </div>
              </div>

              <div class="row"></div>

              <div class="row"></div>

              <div class="row"></div>

              <div class="text-center">
                <p-button
                  type="info"
                  round
                  @click.native.prevent="getOrderByBarcodeID"
                >
                  Shelve Item
                </p-button>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </card>
      </div>
      <div class="col-md-8">
        <div v-if="warning" class="alert alert-danger alert-with-icon" style="font-size:20px;"  data-notify="container">
          <button type="button" aria-hidden="true" @click="close1" class="ti-close"></button>
          <span data-notify="icon" class="ti-pie-chart"></span>
          <br />
          <span data-notify="message"><b>{{warningMessage}}</b></span>
        </div>

        <div v-if="duplicate" class="alert alert-info alert-with-icon" style="font-size:20px;"  data-notify="container">
          <button type="button" aria-hidden="true" @click="close2" class="ti-close"></button>
          <span data-notify="icon" class="ti-pie-chart"></span>
          <br />
          <span data-notify="message"><b>{{duplicateMessage}}</b></span>
        </div>

        <div v-if="ready" class="alert alert-success alert-with-icon" style="font-size:20px;" data-notify="container">
          <button type="button" aria-hidden="true" @click="close3" class="ti-close"></button>
          <span data-notify="icon" class="ti-pie-chart"></span>
          <br />
          <span data-notify="message"><b>{{readyMessage}}</b></span>
          <br />
        </div>
      </div>
    </div>
    <!-- <div class="col-md-4">
      <card class="card" title="Create New Rack">
        <div>
          <p-button
            type="info"
            round
            @click.native.prevent="createNewRack"
          >
            Create New Rack
          </p-button>
        </div>
      </card>
    </div> -->
    
    
  </div>
</template>
<script>
import * as shelveOrderService from "../../services/shelveOrder.service";
import { EventBus } from "@/event-bus";
import { createEmptySpaceArr } from "../../helpers/emptyRacks";
import { spaceMap } from "../../helpers/spaceUnits";
import Card from '../../components/Cards/Card.vue';
import EmptyForm from '../Empty/EmptyForm.vue';
import Vue from 'vue';

//var JsBarcode = require('jsbarcode');

var EmptyClass = Vue.extend(EmptyForm)
var EmptyInstance = new EmptyClass();
EmptyInstance.$mount();

export default {
  name: "shelveform",
  data() {
    return {
      toShelve: {
        barcode: "",
        notes: "",
      },
      racks: null,
      shipReady: false,
      badMessage: "",
      warning: false,
      duplicate: false,
      ready: false,
      warningMessage: "Error! :::: ",
      duplicateMessage: "DUPLICATE! :::: This Item is a duplicate in the order.",
      readyMessage: "",
      binsToEmpty: "",
      exampleBin: null,
    };
  },
  methods: {
    close1: function() {
      this.warning = false;
      this.warningMessage = "Error! :::: ";
    },
    close2: function() {
      this.duplicate = false;

    },
    close3: function() {
      this.ready = false;
      this.readyMessage = "";
    },
    setUpWarning: function(message) {
      this.warningMessage = "ERROR! :::: ";
      this.warningMessage += message;
      this.duplicate = false;
      this.ready = false;
      this.warning = true;
      this.toShelve.barcode = "";
    },
    getOrderByBarcodeID: function () {
      let barcodeID = this.toShelve.barcode;
      if (barcodeID == "") {
        this.setUpWarning("YOU MUST PROVIDE A BARCODE");
        return;
      }
      shelveOrderService
        .getOrderDetails(barcodeID)
        .then((response) => {
          this.readyMessage = "";
          //console.log("response::: " + JSON.stringify(response));
          if (response.items.err) {
            this.setUpWarning(JSON.stringify(response.items.err));
          } else if (response.items.error) {
            this.setUpWarning(JSON.stringify(response.items.error));
          } else {
            this.findLocation(response);
          }
        })
        .catch((err) => {
          console.log("error barcode: " + JSON.stringify(err.message));
          this.setUpWarning(JSON.stringify(err.message));
        });
    },
    findLocation: function(order) {
      let referenceId = order.items["reference_id"];
      //console.log("Finding Location For::::: " + referenceId);
      shelveOrderService.getLocation(referenceId).then(response => {
        //console.log("Found Location");
        //console.log(response);
        let location;
        if (response.items.length > 0) {
          location = response.items[0]["rack"];
        } else {
          location = 0;
        }
        //console.log("Location::::: " + location);
        this.shelve(order, referenceId, location);
        return location;
      })
      .catch((err) => {
        console.log("Error Finding Location: " + JSON.stringify(err.message));
        this.setUpWarning(JSON.stringify(err.message));
      });
      return;
    },
    shelve: function(order, reference_id, location) {
      //console.log("Shelving =>");
      //console.log(order);
      let barcodeID = this.toShelve.barcode;
      shelveOrderService.getBins().then(response => {
        //console.log("Response after Getting Bins:: ");
        //console.log(response);
        //console.log(response.items);
        //console.log(response.items[0]);
        this.racks = JSON.parse(response.items[0]['rackMaps']);
        //console.log(JSON.stringify(this.racks));
        if (location == 0) {
          this.findSpace(order, reference_id, barcodeID);
        } else {
          let currRack = this.racks[location];
          let orderData = currRack[reference_id];

          let currSKU = order["items"]["skus"];
          //console.log("Shelving SKU: ");
          //console.log(currSKU);
          let maxTotalQty = order.items['total_quantity'];
          let maxItemQty = order.items['qty'];

          let shelvedObj = {
            "barcodeID": barcodeID,
            "op_order_id": reference_id,
            "rack": location,
          }
          if (!orderData["skus"][currSKU]) {
            orderData["skus"][currSKU] = 1;
          } else {
            orderData["skus"][currSKU] += 1;
          }
          if (barcodeID in orderData) {
            let itemQty = orderData[barcodeID];
            if (itemQty < maxItemQty) {
              orderData[barcodeID] += 1;
              orderData['total_qty'] += 1;
              shelvedObj["currQty"] = orderData[barcodeID];
              shelvedObj["totalQty"] = orderData['total_qty'];
              this.racks[location][reference_id] = orderData;
              if (orderData['total_qty'] == maxTotalQty) {
                this.shipReady = true;
                orderData['ready'] = true;
              }
              shelveOrderService.shelved(shelvedObj).then(response => {
                //console.log("Item Binned");
                //console.log(response);
                shelveOrderService.updateRacks(this.racks).then(response => {
                  //console.log("Rack Map Updated");
                  //console.log(response);
                  shelveOrderService.storeRacks(this.racks, location).then(response => {
                    //console.log("Rack Histories Updated");
                    //console.log(response);
                    order["items"]["currQty"] = orderData[barcodeID];
                    order["items"]["totalQty"] = orderData['total_qty'];
                    order["items"]["bins"] = JSON.stringify(orderData["bins"]);
                    let myBins = JSON.stringify(orderData["bins"]);
                    this.readyMessage = `SUCCESS!! :::: Item: ${barcodeID} belongs to bin(s) ${myBins}. `
                    if (this.shipReady) {
                      this.readyMessage += "The order is COMPLETE and ready to be shipped";
                      order["items"]["shipReady"] = "YES";
                      let fullBins = order["items"]["bins"];
                      this.exampleBin = orderData["bins"][0];
                      this.showModal(fullBins);
                    } else {
                      order["items"]["shipReady"] = "NO";
                    }
                    this.duplicate = false;
                    this.warning = false;
                    this.ready = true;
                    //console.log("My Order to Table");
                    //console.log(order);
                    this.toShelve.barcode = "";
                    response.items.error ? "swal" : this.emitGetOrderEvent(order);
                  }).catch((err) => {
                    console.log("Error Storing Racks:::: " + JSON.stringify(err.message));
                    console.log(barcodeID);
                    this.setUpWarning(JSON.stringify(err.message));
                  });
                }).catch((err) => {
                  console.log("Error Updating Racks:::: " + JSON.stringify(err.message));
                  console.log(barcodeID);
                  this.setUpWarning(JSON.stringify(err.message));
                });                
              }).catch((err) => {
                console.log("Error Binning Item:::: " + JSON.stringify(err.message));
                console.log(barcodeID);
                this.setUpWarning(JSON.stringify(err.message));
              });
            } else if (itemQty == maxItemQty) {
              //console.log("DUPLICATE");
              this.ready = false;
              this.warning = false;
              this.duplicate = true;
              order["items"]["currQty"] = orderData[barcodeID];
              order["items"]["totalQty"] = orderData['total_qty'];
              order["items"]["bins"] = JSON.stringify(orderData["bins"]);
              if (orderData['ready']) {
                order["items"]["shipReady"] = "YES";
                let fullBins = order["items"]["bins"];
                this.exampleBin = orderData["bins"][0];
                this.showModal(fullBins);
              } else {
                order["items"]["shipReady"] = "NO";
              }
              this.toShelve.barcode = "";
              this.emitGetOrderEvent(order);
            }
          } else {
            orderData[barcodeID] = 1;
            orderData['total_qty'] += 1;
            this.racks[location][reference_id] = orderData;
            if (orderData['total_qty'] == maxTotalQty) {
              this.shipReady = true;
              orderData['ready'] = true;
            }
            shelvedObj["currQty"] = orderData[barcodeID];
            shelvedObj["totalQty"] = orderData['total_qty'];
            shelveOrderService.shelved(shelvedObj).then(response => {
              //console.log("Shelved Items");
              //console.log(response);
              shelveOrderService.updateRacks(this.racks).then(response => {
                //console.log("Updated Racks");
                //console.log(response);
                shelveOrderService.storeRacks(this.racks, location).then(response => {
                  //console.log("Rack Histories Updated");
                  //console.log(response);
                  order["items"]["currQty"] = orderData[barcodeID];
                  order["items"]["totalQty"] = orderData['total_qty'];
                  order["items"]["bins"] = JSON.stringify(orderData["bins"]);
                  let myBins = JSON.stringify(orderData["bins"]);
                  this.readyMessage = `SUCCESS!! :::: Item: ${barcodeID} belongs to bin(s) ${myBins}. `
                  if (this.shipReady) {
                    this.readyMessage += "The order is COMPLETE and ready to be shipped"
                    order["items"]["shipReady"] = "YES";
                    let fullBins = order["items"]["bins"];
                    this.exampleBin = orderData["bins"][0];
                    this.showModal(fullBins);
                  } else {
                    order["items"]["shipReady"] = "NO";
                  }
                  this.duplicate = false;
                  this.warning = false;
                  this.ready = true;
                  this.toShelve.barcode = "";
                  response.items.error ? "swal" : this.emitGetOrderEvent(order);
                }).catch((err) => {
                  console.log("Error Storing Racks:::: " + JSON.stringify(err.message));
                  console.log(barcodeID);
                  this.setUpWarning(JSON.stringify(err.message));
                });
              }).catch((err) => {
                console.log("Error Updating Racks::::" + JSON.stringify(err.message));
                console.log(barcodeID);
                this.setUpWarning(JSON.stringify(err.message));
              });
            }).catch((err) => {
              console.log("Error Binning Item:::: " + JSON.stringify(err.message));
              console.log(barcodeID);
              this.setUpWarning(JSON.stringify(err.message));
            });
          }
        }
      })
      .catch((err) => {
        console.log("Error Finding Bins:::: " + JSON.stringify(err.message));
        this.setUpWarning(JSON.stringify(err.message));
      });
      return;
    },
    findSpace: function(order, reference_id, barcodeID) {
      let mySpace = this.calculateSpace(order);
      if (mySpace == Infinity) {
        return;
      }
      let binsNeeded = mySpace / 12;
      if ((binsNeeded % 1) != 0) {
        binsNeeded = Math.floor(binsNeeded) + 1;
      }
      //console.log("Bins Needed::: " + binsNeeded);

      let locations = Object.keys(this.racks);
      //console.log("Possible Locations::: " + locations);

      let currSKU = order["items"]["skus"];
      //console.log("Shelving SKU: ");
      //console.log(currSKU);

      let currRack;
      let finalRack;
      let currLocation;
      for (let i=0; i < locations.length; i++) {
        currLocation = locations[i];
        currRack = this.racks[currLocation];
        let rackSpace = 48 - currRack['used'];
        if (rackSpace >= binsNeeded) {
          finalRack = currRack;
          break;
        }
      }
      if (finalRack) {
        let binArr = finalRack['spaceArr'];
        let barcodeArr = finalRack['barcodes'];
        let arrCounter = 0;
        let binList = [];
        let barcodeList = [];
        spaceLoop:
        for (let i=0; i < binArr.length; i++) {
          for(let j=0; j < binArr[i].length; j++) {
            arrCounter += 1;
            //console.log("BIN #: " + arrCounter);
            if (binArr[i][j] == 0) {
              let bin = `${currLocation}${arrCounter}`
              binList.push(bin);
              barcodeList.push(barcodeArr[i][j]);
              binArr[i][j] = 1;
              if (binList.length == binsNeeded) {
                //console.log("Space Made For::: " + reference_id);
                break spaceLoop;
              }
            }
          }
        }
        if (binList.length == binsNeeded) {
          //console.log("Barcode::: ")
          //console.log(barcodeID);
          finalRack['spaceArr'] = binArr;
          //let togetherLen = Object.keys(finalRack['together']).length;
          finalRack['together'][reference_id] = barcodeList;
          finalRack['used'] += binsNeeded;
          finalRack[reference_id] = {
            total_qty: 1,
            bins: binList
          }
          finalRack[reference_id][barcodeID] = 1;
          finalRack[reference_id]["skus"] = {};
          finalRack[reference_id]["skus"][currSKU] = 1;
          let maxTotalQty = order.items['total_quantity'];
          finalRack[reference_id]["maxQty"] = maxTotalQty;
          //console.log("FINAL RACK");
          //console.log(finalRack);
          this.racks[currLocation] = finalRack;
          let shelvedObj = {
            "barcodeID": barcodeID,
            "op_order_id": reference_id,
            "rack": currLocation,
            "currQty": 1,
            "totalQty": 1
          }
          shelveOrderService.shelved(shelvedObj).then(response => {
            //console.log("Shelved Items");
            //console.log(response);
            shelveOrderService.updateRacks(this.racks).then(response => {
              //console.log("Updated Racks");
              //console.log(response);
              let locationObj = {
                "referenceId": reference_id,
                "rack": currLocation
              }
              shelveOrderService.storeRacks(this.racks, currLocation).then(response => {
                //console.log("Rack Histories Updated");
                //console.log(response);
                shelveOrderService.storeLocation(locationObj).then(response => {
                  //console.log("Rack Location Saved");
                  //console.log(response);
                  order["items"]["currQty"] = 1;
                  order["items"]["totalQty"] = 1;
                  order["items"]["shipReady"] = "NO";
                  //console.log("My Order to Table!!!!!");
                  //console.log(order);
                  let myBins = JSON.stringify(binList);
                  order["items"]["bins"] = myBins;
                  //let tableOrder = order;
                  //console.log("TABLE ORDER");
                  //console.log(tableOrder);
                  this.readyMessage = `SUCCESS!! :::: Item: ${barcodeID} belongs to bin(s) ${myBins}. `
                  this.duplicate = false;
                  this.warning = false;
                  this.ready = true;
                  this.toShelve.barcode = "";
                  response.items.error ? "swal" : this.emitGetOrderEvent(order);
                }).catch((err) => {
                  console.log("Error Storing Location:::: " + JSON.stringify(err.message));
                  console.log(barcodeID);
                  console.log(currLocation);
                  this.setUpWarning(JSON.stringify(err.message));
                });
              }).catch((err) => {
                console.log("Error Storing Racks:::: " + JSON.stringify(err.message));
                console.log(barcodeID);
                this.setUpWarning(JSON.stringify(err.message));
              });
            }).catch((err) => {
              console.log("Error Updating Racks:::: " + JSON.stringify(err.message));
              console.log(barcodeID);
              this.setUpWarning(JSON.stringify(err.message));
            });
          }).catch((err) => {
            console.log("Error Binning Item:::: " + JSON.stringify(err.message));
            console.log(barcodeID);
            this.setUpWarning(JSON.stringify(err.message));
          });
        }
      } else {
        console.log("NO SPACE Currently Available");
        this.setUpWarning("THERE IS NO SPACE CURRENTLY AVAILABLE");
      }
      return;

    },
    calculateSpace: function(order) {
      let skuObject = order["items"]["order_items"];
      //console.log("SKU Object");
      //console.log(skuObject);
      let finalSpace = 0.0;
      for (let i=0; i < skuObject.length; i++) {
        let mySku = skuObject[i]["sku"];
        //console.log(mySku);
        let myQuantity = skuObject[i]["quantity"];
        let itemSpace = spaceMap[mySku];
        if (!itemSpace) {
          //this.setUpWarning("AT LEAST ONE ITEM IN THE ORDER IS NOT IN THE SPACING SYSTEM.");
          //return Infinity;
          itemSpace = 1;
        }
        finalSpace += (itemSpace * myQuantity);
      }
      //console.log("How Much Space Do I Need?");
      //console.log(finalSpace);
      return finalSpace;
    },
    emitGetOrderEvent: function (order) {
      EventBus.$emit("shelving", order);
    },
    emitEmptyBins: function(bin) {
      //console.log("Emitting");
      EventBus.$emit("emptyBin", bin);
    },
    showModal(bins) {
      this.binsToEmpty = bins;
      //console.log("EXAMPLE BIN: ")
      //console.log(this.exampleBin);
      this.$refs["empty-modal"].show();
    },
    showModal2() {
      this.$refs["emptied-modal"].show();
    },
    hideModal() {
      this.$refs["empty-modal"].hide();
    },
    hideModal2() {
      this.$refs["emptied-modal"].hide();
    },
    emptyMyBin() {
      let binStr = 'OP-';
      let splitBin = this.exampleBin.split("");
      binStr += splitBin[0];
      let zeros;
      if (splitBin[2]) {
        zeros = '-0000';
        binStr += zeros;
        binStr += splitBin[1];
        binStr += splitBin[2];
      } else {
        zeros = '-00000';
        binStr += zeros;
        binStr += splitBin[1];
      }
      //this.emitEmptyBins(binStr);
      //this.$root.$refs.emptyform_component.toEmpty.barcode = binStr;
      //this.$root.$refs.emptyform_component.getOrderByBarcodeID();
      //this.$root.$emit('emptyForm1', binStr);
      EmptyInstance.toEmpty.barcode = binStr;
      EmptyInstance.getOrderByBarcodeID();
      this.hideModal();
      this.showModal2();
    },
    /** Uncomment in case createNewRack in TopNavbar doesn't work. */
    // createNewRack: function () {
    //   const alpha = Array.from(Array(26)).map((e, i) => i + 65);
    //   const alphabet = alpha.map((x) => String.fromCharCode(x));
    //   shelveOrderService.getBins().then(response => {
    //     console.log(response);
    //     if (response.items.error) {
    //       throw new Error(response.items.error);
    //     } else {
    //       let myRacks = JSON.parse(response.items[0]['rackMaps']);
    //       console.log(myRacks);
    //       let rackNumber = Object.keys(myRacks).length;
    //       console.log(rackNumber);
    //       let rackLocation = alphabet[rackNumber];
    //       console.log("New Rack Location: " + rackLocation);
    //       let barcodeArr = createEmptySpaceArr(15);
    //       console.log("Barcode Array before creating barcodes");
    //       console.log(JSON.stringify(barcodeArr));
    //       let arrCounter = 0;
    //       for (let i=0; i < barcodeArr.length; i++) {
    //         for (let j=0; j < barcodeArr[i].length; j++) {
    //           arrCounter += 1;
    //           let currBarcode = `OP-${rackLocation}-`;
    //           let zeros;
    //           if (arrCounter.toString().length == 1) {
    //             zeros = "00000";
    //           } else {
    //             zeros = "0000";
    //           }
    //           currBarcode = currBarcode + zeros + arrCounter;
    //           //let newBarcode = JsBarcode("#barcode", currBarcode);

    //           barcodeArr[i][j] = currBarcode;
    //         }
    //       }
    //       console.log("Barcode Array after creating barcodes");
    //       console.log(JSON.stringify(barcodeArr));
    //       let allRacks;
    //       if (response.items.length > 0) {
    //         allRacks = myRacks;
            
    //         allRacks[rackLocation] = {
    //           spaceArr: createEmptySpaceArr(0),
    //           used: 0,
    //           barcodes: barcodeArr,
    //           together: {}
    //         } 
    //       } else {
    //         allRacks = {};
    //         allRacks[rackLocation] = {
    //           spaceArr: createEmptySpaceArr(0),
    //           used: 0,
    //           barcodes: barcodeArr,
    //           together: {}
    //         }
    //       }
    //       console.log("All Racks");
    //       console.log(allRacks);
    //       shelveOrderService.updateRacks(allRacks).then(response => {
    //         console.log(response);
    //         this.toShelve.barcode = "";
    //       }).catch((err) => {
    //         console.log("Error Updating Racks:::: " + JSON.stringify(err.message));
    //         this.setUpWarning(JSON.stringify(err.message));
    //       });
    //     }
    //   }).catch((err) => {
    //     console.log("Error Grabbing/Creating Racks:::: " + JSON.stringify(err.message));
    //     this.setUpWarning(JSON.stringify(err.message));
    //   });
    // }
  },
};
</script>
<style>
  .modalp {
    word-wrap: break-word;
    white-space: pre-line;
  }
</style>